<template>
  <div class="body" id="bj">
      <Headtow></Headtow>
      <Headfor></Headfor>
      <div >
        <div id="w-center">
          <div class="index_pub_title">
              <p class="pub_d_title">会员中心</p>
              <router-link :to="`/index`" class="pub_duo pub_duo_d">
                 <i class="el-icon-house size-icon"></i> 首页>会员中心
              </router-link>
              <div class="pub_xian"></div>
          </div>
          <div class="h-20"></div>
          <!-- 左侧 -->
          <Memberleft></Memberleft>

          <!-- 左侧结束 -->
          <div class="w-products rihgt">
            <div class="Member-right">
                <p class="content-jj">选购员列表</p>
            </div>
            <div class="w-products rihgt Member-right">
              <div class="member-label DeviceInfos">
                <!-- <el-tabs> -->

                  <!-- <el-tab-pane> -->
                    <!-- <span slot="label">选购员列表</span> -->
                    <el-button  @click="adduser('',1)" type="warning" size="small">添加账号</el-button>
                    <el-table
                        v-loading="loading"
                        ref="multipleTable"
                        :data="list"
                        style="width: 100%"
                        :row-class-name="tableRowClassName"
                        >
                        <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
                        <el-table-column label="登录账号 " width="120">
                          <template slot-scope="scope">{{ scope.row.username }}</template>
                        </el-table-column>
                        <el-table-column label="姓名 " width="120">
                          <template slot-scope="scope">{{ scope.row.name }}</template>
                        </el-table-column>
                        <el-table-column label="电话 " width="120">
                          <template slot-scope="scope">{{ scope.row.mobile }}</template>
                        </el-table-column>
                        <el-table-column label="添加时间" show-overflow-tooltip>
                          <template slot-scope="scope">{{ scope.row.create_time }}</template>
                        </el-table-column>
                       <!-- <el-table-column label="状态 " width="120">
                          <template slot-scope="scope">{{ scope.row.status_text }}</template>
                        </el-table-column> -->
                        <el-table-column label="操作">
                          <template slot-scope="scope">
                            <el-button size="mini" @click="handleEdit(scope.row.id,'2')">编辑</el-button>
                            <el-button v-if="scope.row.status==1" size="mini" type="danger" @click="userDelete(scope.row.id,2)">禁用</el-button>
                            <el-button v-if="scope.row.status==2" size="mini" type="success" @click="userDelete(scope.row.id,1)">开启</el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                      <div class="page">
                        <el-pagination
                          background
                          layout="prev, pager, next"
                          :page-size="8"
                          @current-change="handleCurrentChange"
                          :total="total">
                        </el-pagination>
                      </div>
                  <!-- </el-tab-pane> -->
                  <!-- <el-tab-pane>
                    <span slot="label">添加老师</span>
                  </el-tab-pane> -->


                     <el-dialog title="选购员信息" :visible.sync="dialogTableVisible" width="30%" >
                      <el-form ref="form" :model="form" label-width="100px" v-loading="loading">

                        <el-form-item label="联系人姓名：">
                          <el-input placeholder="请输入联系人姓名"  v-model="form.name"></el-input>
                        </el-form-item>
                        <el-form-item label="电话：">
                          <el-input placeholder="请输入电话"  v-model="form.mobile"></el-input>
                        </el-form-item>
                        <el-form-item label="登录账号：">
                          <el-input placeholder="请输入登录账号"  v-model="form.username"></el-input>
                        </el-form-item>
                        <el-form-item label="设置新密码" prop="pass">
                          <el-input type="password"  placeholder="请设置新密码" v-model="form.pass" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="确认密码"  prop="checkPass">
                          <el-input type="password" placeholder="请确认密码" v-model="form.checkPass" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item>
                          <el-button type="primary" @click="onSubmit(form)" size="medium">提交</el-button>
                        </el-form-item>
                      </el-form>
                    </el-dialog>



                <!-- </el-tabs> -->
              </div>
              <div class="h-30"></div>
              <div class="h-30 clear"></div>
              <div class="h-30"></div>
            </div>

          </div>

          <div class="clear"></div>

        </div>
      </div>
       <Foot></Foot>
  </div>

</template>
<style>
  .el-table .warning-row {
    /* background: oldlace; */
  }
    .el-table .warning-row .cell{
      color: #d6d6d6;
    }

  .el-table .success-row {
    background: #f0f9eb;
  }
</style>
<script>
import headtow from '@/components/public/headtow.vue';
import foot from '@/components/public/foot.vue';
import headfor from '@/components/public/headfor.vue';
import memberleft from '@/components/public/memberleft.vue'
export default{
  data(){
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.form.checkPass !== '') {
          this.$refs.form.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
     dialogTableVisible:false,
     loading:true,
     activeIndex: '3',
     imageUrl: '',
     user:[],
     form: {
         name: '',
         username:'',
         // sex:'',
         // headimgurl:'',
         pass:'',
         checkPass:'',
         mobile:'',
     },
     rules: {
       pass: [
         {  required: true,validator: validatePass, trigger: 'blur' }
       ],
       checkPass: [
         {  required: true,validator: validatePass2, trigger: 'blur'}
       ],
     },

     list: [],
     page:1,
     total:0,
     type:0,
     bjuserid:0,

    }
  },
  components: {
    'Headtow': headtow,  //将别名demo 变成 组件 Demo
    'Foot': foot,
    'Headfor': headfor,
    'Memberleft': memberleft,
  },




  mounted () {
    this.recordapi();
  },
  methods:{


     tableRowClassName({row, rowIndex}) {
       console.log(row);
        if (row.status === 2) {
          return 'warning-row';
        }
        return '';
      },


    userDelete(e,zt){
        if(zt==1){
          var text = "此操作开启该采购员, 是否继续?";
        }else{
          var text = "此操作禁用该采购员, 是否继续?"
        }
      this.$confirm(text, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var that = this;
          var userid = that.$cookieStore.getCookie('userid');
          that.$api.post("/Member/userdelete",{'status':zt,'id':this.$encruption(e.toString())}).then(res => {
            console.log(res);
            if(res.code==1){
              this.$message({
                message: res.msg,
                type: 'success'
              });
              this.recordapi();
            }else{
             this.$message.error(res.msg);
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消操作'
          });
        });
    },
    adduser() {
      var that = this;
      var userid = that.$cookieStore.getCookie('userid');
      this.handleEdit(userid,1)
    },
    // 编辑用户资料
    handleEdit(index, row) {
      console.log(index)
      console.log(row)

      var that = this;
      that.dialogTableVisible = true
      that.type = row;
      that.bjuserid = index
      that.$api.post("/Member/info",{'id':this.$encruption(index.toString()),'type':row}).then(res => {
        console.log(res);
         if(res.code == 1){
           that.form= res.user;
           this.loading = false
         }
      });


       // this.$router.push({path:'/MemberInfoedit',query:{id:row.id,memberindex:2,index:4}});
    },
    recordapi(){
        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        console.log(userid);
        that.$api.post("/Member/MemberInfo",{'userid':userid}).then(res => {
          console.log(res);
           if(res.code == 1){
             that.user= res.user;
             this.list = res.list.data;
             this.total = res.list.total
             this.loading = false

           }

        });
    },
    // 分页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.recordapi();
    },

   // 添加提交
   onSubmit(form) {
     console.log(form);
     var that = this;
     if(that.type == 1){
       if(form.checkPass !== form.pass ){
          this.$message.error('俩次密码输入不一样');
          return
       }
       if(form.checkPass =='' ||  form.pass=='' ){
         this.$message.error('请输入密码');
         return
       }
       var userid = that.$cookieStore.getCookie('userid');
     }else{
       var userid = this.$encruption(that.bjuserid.toString());
     }



       that.$api.post("/Member/addls",{'password':form.checkPass,'userid':userid,'name':form.name,'username':form.username,'mobile':form.mobile,'type':that.type}).then(res => {
           console.log(res);
           if(res.code==1){
             that.show = false;
             this.$message({
               message: res.msg,
               type: 'success'
             });
             that.dialogTableVisible = false
             this.recordapi();
             // this.form.username = '';
             // this.form.pass = '';
             // this.form.checkPass = '';
             // this.form.mobile = '';
           }
       })

   },

  }

 }
</script>



// WEBPACK FOOTER //
// src/components/MemberInfo.vue